<template>
  <AppContainer class="my-10 md:my-20">
    <div class="row">
      <div class="col-lg-1"></div>

      <div class="col-lg-8">
        <AppButton class="mb-3 md:mb-6" variant="text" to="/faqs">
          <template #icon-start-circle><IconChevronLeft /></template>
          {{ $t('string.Back') }}
        </AppButton>

        <h1 class="h2 mb-6 md:mb-12">{{ title }}</h1>

        <UiAccordion :items="items" :default-open="0" />
      </div>
    </div>
  </AppContainer>
</template>

<script lang="ts" setup>
import UiAccordion from '@boats/ui/components/UiAccordion.vue'
import { fetchApi, queryKey } from '~/queries'

const route = useRoute()

const path = route.params.path

const slug = path[1]

const { data } = await useAsyncData(queryKey('faq', slug), async () => {
  if (!slug) return

  const data = await fetchApi(`/faqs/show-by`, {
    query: {
      'search[slug]': slug,
      'with[]': ['faqItems'],
    },
  })

  return data
})

const title = data?.value?.translation?.data?.name

const items = data?.value?.items
  ?.sort((a: any, b: any) => a.data.position - b.data.position)
  .map((item: any) => ({
    title: item.translation.data.question,
    content: item.translation.data.answer,
  }))

useSeoMeta({
  title: title,
})
</script>
